import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime nesciunt
        porro voluptatibus soluta doloremque quam! Explicabo, ad est a sint,
        dicta quos cumque voluptate ea quisquam laborum fugiat officia
        consectetur dolores praesentium. Suscipit repudiandae porro ducimus sed
        doloribus, eius magnam.
      </p>
    </section>
  );
};

export default About;
